<script setup lang="ts">
withDefaults(defineProps<{ count?: number }>(), { count: 3 })
</script>

<template>
  <div class="animate-pulse px-8">
    <div v-for="_ in count">
      <div class="mb-4 border-b border-neutral-200 pb-2">
        <div class="h-5.5 w-26 rounded-lg bg-neutral-200" />
      </div>
      <div class="h-33 rounded-lg bg-neutral-200" />
      <div class="h-33 mb-8 mt-4 rounded-lg bg-neutral-200" />
    </div>
  </div>
</template>
